import MangaCard from '@/components/base/MangaCard';
import { getHotManga } from '@/mocks/manga';

export default function HotRecommend() {
  const hotManga = getHotManga();

  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在看的精彩漫画</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
        {hotManga.map((manga) => (
          <MangaCard key={manga.id} manga={manga} variant="featured" />
        ))}
      </div>
    </section>
  );
}